import { yup } from '@framework/validation/initYup.ts';
import { useMemo } from 'react';
import {
  Datatype,
  type FieldDatatype,
} from '../../../../expressions/datatype/Datatype.ts';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { WidgetType } from '../../../Widget.ts';
import { DefaultValueInput } from '../../common/DefaultValueInput.tsx';
import { AdvancedSelectOptionItemList } from '../advanced-select-common/config/AdvancedSelectOptionItemList.tsx';
import { AdvancedSelectWidgetConfigComponent } from '../advanced-select-common/config/AdvancedSelectWidgetConfigComponent.tsx';
import { AdvancedSelectWidgetCommonConfigSchema } from '../advanced-select-common/config/AdvancedSelectWidgetConfigSchema.ts';
import { getUniqueOptionValue } from '../advanced-select-common/utils/geUniqueOptionValue.ts';
import { renderAdvancedSelectedOptionLabel } from '../advanced-select-common/utils/renderAdvancedSelectedOptionLabel.ts';
import { type IAdvancedMultiSelectWidget } from './IAdvancedMultiSelectWidget.ts';

export const AdvancedMultiSelectWidgetConfigSchema =
  AdvancedSelectWidgetCommonConfigSchema.shape({
    type: yup.string().exact(WidgetType.AdvancedMultiSelect).required(),
  });

export interface IAdvancedMultiSelectWidgetConfigComponentProps
  extends IWidgetComponentProps<IAdvancedMultiSelectWidget> {}

/**
 * Componente di configurazione del widget di selezione multipla avanzata
 */
export function AdvancedMultiSelectWidgetConfigComponent(
  props: IAdvancedMultiSelectWidgetConfigComponentProps,
) {
  const fieldDatatype: FieldDatatype = useMemo(() => {
    return {
      type: Datatype.Array,
      itemsType: Datatype.String,
      options: props.widget.options.map(opt => ({
        value: getUniqueOptionValue(props.widget, opt),
        label: renderAdvancedSelectedOptionLabel(
          opt.values,
          props.widget.labelFieldColumns,
          props.widget.columns,
        ),
      })),
    };
  }, [props.widget]);

  return (
    <AdvancedSelectWidgetConfigComponent
      {...props}
      panelTitle="Scelta Multipla Avanzata"
      panelKey="advancedMultiSelect"
      optionListComponent={<AdvancedSelectOptionItemList name="options" />}
      labelFieldColumnsHelp="Seleziona le colonne da mostrare riguardo le opzioni selezionate (es: Nome - Cognome - Città). Le colonne verranno visualizzate nell'ordine in cui vengono configurate."
      defaultNode={<DefaultValueInput forceFieldDataType={fieldDatatype} />}
    />
  );
}
